<template>
  <div class="flex flex-col h-full bg-cream select-none">

    <!-- ═══ Таб-бар: fixed 72px, blur ═══ -->
    <div class="fixed top-0 left-1/2 -translate-x-1/2 w-full max-w-[430px] z-50 flex items-end"
         style="height: calc(72px + var(--safe-top)); background: rgba(235, 225, 210, 0.6); -webkit-backdrop-filter: blur(20px); backdrop-filter: blur(20px);">
      <button
        v-for="(tab, idx) in tabs"
        :key="tab.key"
        @click="onTabClick(tab.key)"
        class="flex-1 flex flex-col items-center justify-end transition-colors relative"
        :class="{
          'tab-active': activeTab === tab.key,
          'tab-first': idx === 0,
          'tab-last': idx === tabs.length - 1,
        }"
        :style="[
          activeTab === tab.key
            ? 'background: rgba(250, 243, 232, 0.75); z-index: 2;'
            : 'background: transparent; z-index: 1;',
          'height: 72px; padding-bottom: 12px;',
          idx === 0 ? 'border-radius: 0 14px 0 0;'
            : idx === tabs.length - 1 ? 'border-radius: 14px 0 0 0;'
            : 'border-radius: 14px 14px 0 0;'
        ]"
      >
        <div class="flex-1 flex items-end pb-1" :style="{ opacity: activeTab === tab.key ? 1 : 0.6, color: '#41291A' }" v-html="tab.svg" />
        <span style="font-family: Inter, sans-serif; font-weight: 400; font-size: var(--fs-12); line-height: 1;"
              :style="{ color: activeTab === tab.key ? '#41291A' : 'rgba(65,41,26,0.6)' }">{{ tab.label }}</span>
      </button>
    </div>

    <!-- Контент (pt-[72px] под fixed таб-бар) -->
    <div class="flex-1 overflow-y-auto pt-[72px] pb-24" ref="mainScrollRef">

      <!-- ══ ПРОДУКТЫ ══ -->
      <div v-show="activeTab === 'products'">

        <!-- Поиск -->
        <div class="px-4 pt-3 pb-2">
          <div class="relative">
            <input
              ref="inputRef"
              v-model="searchQuery"
              type="text"
              placeholder="Поиск продукта..."
              class="w-full h-11 pl-4 rounded-2xl bg-white text-ink text-17 font-medium outline-none focus:ring-0"
              :class="searchQuery ? 'pr-10' : 'pr-[5.5rem]'"
              @input="onSearchInput"
              autocomplete="off"
              autocorrect="off"
              spellcheck="false"
            />
            <!-- Когда есть текст — крестик очистки -->
            <button
              v-if="searchQuery"
              @click="clearSearch"
              class="absolute right-3 top-1/2 -translate-y-1/2 text-ink/60"
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round">
                <line x1="18" y1="6" x2="6" y2="18"/>
                <line x1="6" y1="6" x2="18" y2="18"/>
              </svg>
            </button>
            <!-- Когда нет текста — иконки добавления нового продукта и штрихкода -->
            <div v-else class="absolute right-2 top-1/2 -translate-y-1/2 flex items-center gap-1">
              <button
                @click="showManualProduct = true"
                class="w-10 h-10 flex items-center justify-center rounded-xl text-ink active:bg-[#E0D9CF] transition-colors"
              >
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
                  <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
                </svg>
              </button>
              <button
                @click="showBarcodeScanner = true"
                class="w-10 h-10 flex items-center justify-center rounded-xl text-ink active:bg-[#E0D9CF] transition-colors"
              >
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round">
                  <path d="M2 4h2v16H2zM6 4h1v16H6zM10 4h2v16h-2zM15 4h1v16h-1zM19 4h3v16h-3z"/>
                </svg>
              </button>
            </div>
          </div>
        </div>

        <!-- Рейтинги нутриентов (дефолт, когда нет поиска и нет выбранного нутриента) -->
        <div v-if="!searchQuery && !selectedNutrient" class="px-4 pt-2">

          <p class="text-20 font-semibold text-ink mb-4" style="font-family: Inter, sans-serif; line-height: 1.2;">Рейтинги продуктов по содержанию нутриентов</p>

          <!-- Витамины -->
          <p class="text-14 text-ink mb-2" style="font-family: Inter, sans-serif; font-weight: 400;">Витамины</p>
          <div class="flex flex-wrap gap-2 mb-4">
            <button
              v-for="n in vitaminNutrients"
              :key="n.key"
              @click="selectNutrient(n)"
              class="rounded-lg nutrient-pill"
              :style="{ background: n.color }"
            >{{ n.label }}</button>
          </div>

          <!-- Минералы -->
          <p class="text-14 text-ink mb-2" style="font-family: Inter, sans-serif; font-weight: 400;">Минералы</p>
          <div class="flex flex-wrap gap-2 mb-4">
            <button
              v-for="n in mineralNutrients"
              :key="n.key"
              @click="selectNutrient(n)"
              class="rounded-lg nutrient-pill"
              :style="{ background: n.color }"
            >{{ n.label }}</button>
          </div>

          <!-- Прочие нутриенты -->
          <p class="text-14 text-ink mb-2" style="font-family: Inter, sans-serif; font-weight: 400;">Прочие нутриенты</p>
          <div class="flex flex-wrap gap-2 mb-4">
            <button
              v-for="n in otherNutrients"
              :key="n.key"
              @click="selectNutrient(n)"
              class="rounded-lg nutrient-pill"
              :style="{ background: n.color }"
            >{{ n.label }}</button>
          </div>

        </div>

        <!-- Рейтинг по выбранному нутриенту -->
        <div v-else-if="!searchQuery && selectedNutrient" class="px-4 pt-2">
          <button @click="selectedNutrient = null" class="flex items-center gap-1 mb-3 text-13 text-ink/70">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="15 18 9 12 15 6"/></svg>
            Назад к рейтингам
          </button>

          <p class="text-15 font-semibold text-ink mb-3">Топ продуктов по: {{ selectedNutrient.label }}</p>

          <div v-if="rankingLoading" class="flex justify-center pt-8">
            <div class="w-6 h-6 border-2 border-sand border-t-[#8B7B6B] rounded-full animate-spin"/>
          </div>

          <div v-else-if="rankingProducts.length > 0">
            <div
              v-for="(item, idx) in rankingProducts"
              :key="item.id"
              @click="onProductSelect(item)"
              class="flex items-start gap-3 py-2.5 border-b border-[#EDE5D8] last:border-0 active:bg-[#EDE5D8] transition-colors cursor-pointer"
            >
              <span class="text-12 font-medium shrink-0 leading-[1.35]" style="width: 28px; text-align: right; color: var(--ink);">{{ idx + 1 }}</span>
              <div class="flex-1 min-w-0">
                <p class="text-14 text-ink leading-snug line-clamp-2">{{ item.name }}</p>
                <span
                  v-if="rankingSourceBadge(item.source)"
                  class="text-11 font-medium"
                  :style="{ color: rankingSourceBadge(item.source).color }"
                >✓ {{ rankingSourceBadge(item.source).label }}</span>
              </div>
              <div class="shrink-0 text-right">
                <span class="text-14 font-semibold text-ink leading-[1.35]">{{ formatValue(item.value) }} <span class="text-11 font-normal text-ink/70">{{ item.unit }}</span></span>
                <p v-if="normPct(item.value) != null" class="text-11 text-ink/70 leading-tight">{{ normPct(item.value) }}% нормы</p>
              </div>
            </div>
          </div>

          <div v-else class="text-center pt-8">
            <p class="text-14 text-ink/70">Нет данных для этого нутриента</p>
          </div>
        </div>

        <!-- Результаты поиска продуктов -->
        <div v-if="searchQuery" class="px-4" ref="listRef">
          <div v-if="loading && products.length === 0" class="flex justify-center pt-16">
            <div class="w-6 h-6 border-2 border-sand border-t-[#8B7B6B] rounded-full animate-spin"/>
          </div>
          <template v-else>
            <ProductCard v-for="product in products" :key="product.id" :product="product" @select="onProductSelect"/>
            <div v-if="loadingMore" class="flex justify-center py-4">
              <div class="w-5 h-5 border-2 border-sand border-t-[#8B7B6B] rounded-full animate-spin"/>
            </div>
            <div ref="productSentinelRef" class="h-1" />
            <div v-if="!hasMore && products.length > 0" class="text-center py-6 text-ink/70 text-13">
              Показано {{ products.length }} продуктов
            </div>
            <div v-if="fetchError && products.length === 0" class="text-center pt-16 px-4">
              <p class="text-16 text-ink/70 font-medium">Нет подключения к базе</p>
              <p class="text-13 text-ink/70 mt-1 leading-relaxed">База данных доступна только с сервера.</p>
            </div>
            <div v-if="!loading && !fetchError && products.length === 0" class="text-center pt-16">
              <p class="text-15 font-semibold text-ink">По запросу «{{ searchQuery }}» продукты не найдены</p>
              <button
                @click="showManualProduct = true"
                class="mt-4 px-6 py-3 rounded-2xl text-15 font-semibold"
                style="background: #41291A; color: var(--cream);"
              >Добавить новый продукт</button>
            </div>
          </template>
        </div>
      </div>

      <!-- ══ СТАТЬИ ══ -->
      <div v-show="activeTab === 'articles'">

        <!-- Поиск статей -->
        <div class="px-4 pt-3 pb-2">
          <div class="relative">
            <input
              ref="articleInputRef"
              v-model="articleQuery"
              type="text"
              placeholder="Поиск статьи..."
              class="w-full h-11 pl-4 pr-10 rounded-2xl bg-white text-ink text-17 font-medium outline-none focus:ring-0"
              @input="onArticleSearchInput"
              autocomplete="off"
              autocorrect="off"
              spellcheck="false"
            />
            <button
              v-if="articleQuery"
              @click="clearArticleSearch"
              class="absolute right-3 top-1/2 -translate-y-1/2 text-ink/60"
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round">
                <line x1="18" y1="6" x2="6" y2="18"/>
                <line x1="6" y1="6" x2="18" y2="18"/>
              </svg>
            </button>
          </div>
        </div>

        <div class="px-4" ref="articleListRef">
          <div v-if="articlesLoading && articles.length === 0" class="flex justify-center pt-16">
            <div class="w-6 h-6 border-2 border-sand border-t-[#8B7B6B] rounded-full animate-spin"/>
          </div>

          <template v-else>
            <RouterLink
              v-for="article in articles"
              :key="article.id"
              :to="`/knowledge/articles/${article.slug}`"
              class="flex gap-3 py-3 border-b border-[#E5DFD5] last:border-0"
            >
              <img
                v-if="article.cover_url"
                :src="imgUrl(article.cover_url)"
                alt=""
                loading="lazy"
                class="w-20 h-20 rounded-xl object-cover flex-shrink-0 bg-[#E5DFD5]"
              />
              <div v-else class="w-20 h-20 rounded-xl flex-shrink-0 bg-[#E5DFD5]"/>

              <div class="flex-1 min-w-0">
                <p class="text-15 font-medium text-ink leading-snug line-clamp-2">
                  {{ article.title }}
                </p>
                <p class="mt-1 text-13 text-ink/70 line-clamp-2 leading-snug" v-html="article.excerpt"></p>
                <div class="mt-1.5 flex items-center gap-2 text-12 text-ink/70">
                  <span v-if="article.category">{{ article.category }}</span>
                  <span v-if="article.category && article.word_count">·</span>
                  <span v-if="article.word_count">{{ Math.ceil(article.word_count / 200) }} мин</span>
                </div>
              </div>
            </RouterLink>

            <div v-if="articlesLoadingMore" class="flex justify-center py-4">
              <div class="w-5 h-5 border-2 border-sand border-t-[#8B7B6B] rounded-full animate-spin"/>
            </div>
            <div ref="articleSentinelRef" class="h-1" />
            <div v-if="!articlesHasMore && articles.length > 0" class="text-center py-6 text-ink/70 text-13">
              Показано {{ articles.length }} из {{ articlesTotal }}
            </div>
            <div v-if="!articlesLoading && articles.length === 0" class="text-center pt-16">
              <p class="text-16 text-ink/70 font-medium">Ничего не найдено</p>
            </div>
          </template>
        </div>
      </div>

      <!-- ══ ЭНЦИКЛОПЕДИЯ ══ -->
      <div v-show="activeTab === 'encyclopedia'">
        <Encyclopedia />
      </div>

    </div>

    <!-- Попап продукта -->
    <ProductDetails
      v-if="productDetails"
      :product="productDetails"
      :sex="userSex"
      :age="userAge"
      @close="productDetails = null"
      @updated="onProductUpdated"
    />

    <!-- Диалог ручного добавления нового продукта -->
    <LabelReviewDialog
      v-if="showManualProduct"
      v-model="showManualProduct"
      :show-barcode-scanner="true"
      :start-in-review="true"
      @submitted="onManualProductSubmitted"
    />

    <!-- Сканер штрихкода (selectOnly — возвращает продукт, не добавляет в дневник) -->
    <BarcodeScannerDialog
      v-if="showBarcodeScanner"
      v-model="showBarcodeScanner"
      :select-only="true"
      @select="onBarcodeSelect"
    />

  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted, onUnmounted, nextTick, defineAsyncComponent } from 'vue'
import { RouterLink, onBeforeRouteLeave } from 'vue-router'
import api from '../services/api.js'
import { useAuthStore } from '../store/auth.js'
import ProductCard from '../components/ProductCard.vue'
import ProductDetails from '../components/ProductDetails.vue'
import LabelReviewDialog from '../components/LabelReviewDialog.vue'
import BarcodeScannerDialog from '../components/BarcodeScannerDialog.vue'
import { lazyLoad } from '../utils/lazyLoad.js'
import { imgUrl, absolutizeHtml } from '../utils/image.js'
const Encyclopedia = defineAsyncComponent(lazyLoad(() => import('../components/Encyclopedia.vue')))

const authStore = useAuthStore()
const userSex = computed(() => authStore.user?.sex || 'female')  // пол не указан → женский
const userAge = computed(() => {
  const bd = authStore.user?.birth_date
  if (!bd) return null
  return Math.floor((Date.now() - new Date(bd).getTime()) / (365.25 * 24 * 60 * 60 * 1000))
})

// ── Вкладки ───────────────────────────────────────────────
const tabs = [
  { key: 'products', label: 'Продукты', svg: '<svg width="20" height="20" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.3898 10.3882C12.2334 8.54469 12.4542 6.18986 11.9004 4.35191C11.7999 4.01825 11.8513 3.65749 12.0154 3.35005C12.4565 2.5235 12.4683 1.66733 11.8148 1.01385C11.1609 0.359992 10.3042 0.372154 9.47721 0.813982C9.1699 0.978152 8.80927 1.02977 8.47565 0.929452C6.63818 0.376894 4.28506 0.598601 2.44259 2.44106C0.600876 4.28277 0.378601 6.63471 0.930286 8.47185C1.03047 8.80544 0.978746 9.16598 0.814506 9.47314C0.372162 10.3004 0.359733 11.1576 1.01386 11.8117C1.66708 12.4649 2.52283 12.4534 3.34907 12.0128C3.65662 11.8489 4.01748 11.7975 4.35116 11.8982C6.18945 12.4528 8.54546 12.2325 10.3898 10.3882Z" stroke="currentColor"/><path d="M7.76465 2.82091C6.56084 2.45891 5.0192 2.60415 3.81212 3.81124C3.15011 4.47325 2.80748 5.23588 2.69275 5.98823" stroke="currentColor" stroke-linecap="round"/></svg>' },
  { key: 'articles', label: 'Статьи', svg: '<svg width="21" height="20" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.5 0.5H9" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/><path d="M13.5 3.5H9" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/><path d="M13.5 6.5H9" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/><path d="M13.5 12.5H0.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/><path d="M13.5 9.5H0.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/><path d="M6 0.5H1C0.723858 0.5 0.5 0.72386 0.5 1V6C0.5 6.27614 0.723858 6.5 1 6.5H6C6.27614 6.5 6.5 6.27614 6.5 6V1C6.5 0.72386 6.27614 0.5 6 0.5Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>' },
  { key: 'encyclopedia', label: 'Энциклопедия', svg: '<svg width="18" height="21" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.5 13.5H2C1.60218 13.5 1.22064 13.342 0.93934 13.0607C0.65804 12.7794 0.5 12.3978 0.5 12C0.5 11.6022 0.65804 11.2206 0.93934 10.9393C1.22064 10.658 1.60218 10.5 2 10.5H10.5C10.7652 10.5 11.0196 10.3946 11.2071 10.2071C11.3946 10.0196 11.5 9.76522 11.5 9.5V1.5C11.5 1.23478 11.3946 0.98043 11.2071 0.792893C11.0196 0.605357 10.7652 0.5 10.5 0.5H2C1.60901 0.499861 1.23342 0.652394 0.95324 0.925105C0.67305 1.19782 0.51043 1.56915 0.5 1.96V11.96" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/><path d="M10.5 10.5V13.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/><path d="M7.05149 5.00195H9.36651L6.9068 8.47454H9.51121" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/><path d="M2.51172 5.98553L3.57774 2.78747C3.63239 2.62352 3.78581 2.51294 3.95863 2.51294C4.13145 2.51294 4.28488 2.62352 4.33952 2.78747L5.40554 5.98553M2.89756 4.828H5.0197" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>' },
]
const activeTab = ref(sessionStorage.getItem('kb_activeTab') || 'products')

function onTabClick(key) {
  activeTab.value = key
  sessionStorage.setItem('kb_activeTab', key)
}

// Save scroll position before leaving route
onBeforeRouteLeave(() => {
  if (mainScrollRef.value) {
    sessionStorage.setItem('kb_scrollTop', String(mainScrollRef.value.scrollTop))
  }
})

// ── Рейтинги нутриентов ──────────────────────────────────
// Цвета пилюль — из дневника: витамины — зелёный VitaminBlock (все одним
// цветом, без деления на жиро- и водорастворимые — решение владельца
// 25.10.2026), минералы — розовые, клетчатка, насыщенные жиры и омега-3 —
// цветами своих полосок MacroBar в Diary.vue, ПНЖК — цветом жиров, ретинол —
// жёлтым витамина A из дневника. Витамины, минералы и ретинол — на 35 % ближе
// к кремовому фону #FAF3E8, чем в дневнике: сплошные пилюли дневниковых
// цветов слишком яркие. Исходные: #7EB04E, #D476A5, #DEAE00 — поменяли в
// дневнике, пересчитать и здесь.
const NUTRIENT_COLORS = {
  vitamin: '#A9C884',
  mineral: '#E1A2BC',
  retinol: '#E8C651',
  fiber: '#A6B779',
  sfa: '#d7aa49',
  omega3: '#eecf8a',
  fat: '#EBC06D',
}

const vitaminNutrients = [
  { key: 'A',   jsonKey: 'Витамин А, РЭ',                    label: 'A' },
  { key: 'C',   jsonKey: 'Витамин C, аскорбиновая',          label: 'C' },
  { key: 'D',   jsonKey: 'Витамин D, кальциферол',           label: 'D' },
  { key: 'E',   jsonKey: 'Витамин Е, альфа токоферол, ТЭ',   label: 'E' },
  { key: 'K',   jsonKey: 'Витамин К, филлохинон',            label: 'K' },
  { key: 'B1',  jsonKey: 'Витамин В1, тиамин',               label: 'B1' },
  { key: 'B2',  jsonKey: 'Витамин В2, рибофлавин',           label: 'B2' },
  { key: 'B3',  jsonKey: 'Витамин РР, НЭ',                   label: 'B3' },
  { key: 'B5',  jsonKey: 'Витамин В5, пантотеновая',         label: 'B5' },
  { key: 'B6',  jsonKey: 'Витамин В6, пиридоксин',           label: 'B6' },
  { key: 'B7',  jsonKey: 'Витамин Н, биотин',                label: 'B7' },
  { key: 'B9',  jsonKey: 'Витамин В9, фолаты',               label: 'B9' },
  { key: 'B12', jsonKey: 'Витамин В12, кобаламин',           label: 'B12' },
].map(n => ({ ...n, color: NUTRIENT_COLORS.vitamin }))

const mineralNutrients = [
  { key: 'K_m', jsonKey: 'Калий, K',    label: 'K' },
  { key: 'Ca',  jsonKey: 'Кальций, Ca', label: 'Ca' },
  { key: 'Mg',  jsonKey: 'Магний, Mg',  label: 'Mg' },
  { key: 'Na',  jsonKey: 'Натрий, Na',  label: 'Na' },
  { key: 'Fe',  jsonKey: 'Железо, Fe',  label: 'Fe' },
  { key: 'I',   jsonKey: 'Йод, I',      label: 'I' },
  { key: 'Cu',  jsonKey: 'Медь, Cu',    label: 'Cu' },
  { key: 'Se',  jsonKey: 'Селен, Se',   label: 'Se' },
  { key: 'Mn',  jsonKey: 'Марганец, Mn',label: 'Mn' },
  { key: 'Cr',  jsonKey: 'Хром, Cr',    label: 'Cr' },
  { key: 'Mo',  jsonKey: 'Молибден, Mo',label: 'Mo' },
  { key: 'Zn',  jsonKey: 'Цинк, Zn',   label: 'Zn' },
  { key: 'P',   jsonKey: 'Фосфор, P',   label: 'P' },
].map(n => ({ ...n, color: NUTRIENT_COLORS.mineral }))

const otherNutrients = [
  { key: 'fiber',  jsonKey: 'Пищевые волокна',                label: 'Клетчатка', color: NUTRIENT_COLORS.fiber },
  { key: 'omega3', jsonKey: 'Омега-3 жирные кислоты',         label: 'Омега-3',   color: NUTRIENT_COLORS.omega3 },
  { key: 'pufa',   jsonKey: 'Полиненасыщенные жирные кислоты', label: 'ПНЖК',      color: NUTRIENT_COLORS.fat },
  { key: 'sfa',    jsonKey: 'Насыщенные жирные кислоты',       label: 'НЖК',       color: NUTRIENT_COLORS.sfa },
  { key: 'retinol', jsonKey: 'Ретинол',                        label: 'Ретинол',   color: NUTRIENT_COLORS.retinol },
]

const selectedNutrient = ref(null)
const rankingProducts  = ref([])
const rankingLoading   = ref(false)

async function selectNutrient(n) {
  selectedNutrient.value = n
  rankingLoading.value = true
  rankingProducts.value = []
  try {
    const { data } = await api.get('/products/ranking', {
      params: { nutrient: n.jsonKey, limit: 250 },
    })
    rankingProducts.value = data.products || []
  } catch (err) {
    console.error('Ranking error:', err)
  } finally {
    rankingLoading.value = false
  }
}

function rankingSourceBadge(source) {
  const s = (source || '').toLowerCase()
  if (s.includes('скурихин') || s.includes('skurikhin')) return { label: 'Скурихин', color: '#2D6A4F' }
  if (s.includes('usda')) return { label: 'USDA', color: '#1A5A7A' }
  return null
}

function formatValue(val) {
  if (val == null) return '—'
  if (val >= 1000) return Math.round(val).toLocaleString('ru-RU')
  if (val >= 100) return Math.round(val)
  if (val >= 10) return Math.round(val * 10) / 10
  return Math.round(val * 100) / 100
}

// ── Нормы для расчёта % ──────────────────────────────────
const RDI = {
  A:   { m: 900,  f: 700  },
  D:   { both: 15         },
  E:   { both: 15         },
  K:   { m: 120,  f: 90   },
  C:   { m: 90,   f: 75   },
  B1:  { both: 1.1        },
  B2:  { both: 1.1        },
  B3:  { both: 14         },
  B5:  { both: 5          },
  B6:  { both: 1.3        },
  B7:  { both: 30         },
  B9:  { both: 400        },
  B12: { both: 2.4        },
  K_m: { both: 2600       },
  Ca:  { both: 1000       },
  Mg:  { m: 400, f: 310   },
  Na:  { both: 1500       },
  Cl:  { both: 2300       },
  Fe:  { m: 8,   f: 18    },
  I:   { both: 150        },
  Cu:  { both: 900        },
  Se:  { both: 55         },
  Mn:  { both: 1.8        },
  Cr:  { both: 25         },
  Mo:  { both: 45         },
  Zn:  { m: 11,  f: 8     },
  P:   { both: 700        },
}

function getNorm(nutrientKey) {
  const sex = userSex.value
  // Макронутриенты — из профиля пользователя
  const u = authStore.user
  if (nutrientKey === 'protein') return u?.protein_norm_max || 120
  if (nutrientKey === 'fat')     return u?.fat_norm_max || 100
  if (nutrientKey === 'carbs')   return u?.carbs_norm_max || 300
  if (nutrientKey === 'fiber')   return 30
  if (nutrientKey === 'kcal')    return u?.kcal_intake_norm || 2000
  // Витамины/минералы — из RDI
  const rdi = RDI[nutrientKey]
  if (!rdi) return null
  return rdi.both ?? ((sex === 'f' || sex === 'female') ? rdi.f : rdi.m)
}

function normPct(value) {
  if (!selectedNutrient.value || value == null) return null
  const norm = getNorm(selectedNutrient.value.key)
  if (!norm) return null
  return Math.round((value / norm) * 100)
}

// ── Продукты (поиск) ─────────────────────────────────────
const searchQuery  = ref('')
const products     = ref([])
const loading      = ref(false)
const loadingMore  = ref(false)
const hasMore      = ref(true)
const offset       = ref(0)
const fetchError   = ref(null)
const LIMIT        = 20
const inputRef     = ref(null)
const listRef      = ref(null)
const mainScrollRef = ref(null)
const productDetails = ref(null)
const showManualProduct = ref(false)
const showBarcodeScanner = ref(false)
let debounceTimer  = null

async function onProductSelect(product) {
  try {
    const { data } = await api.get(`/products/${product.id}`)
    productDetails.value = data
  } catch (err) {
    console.error('Product details error:', err)
  }
}

async function onProductUpdated(updatedProduct) {
  // Оптимистичное обновление из ответа PUT
  productDetails.value = { ...productDetails.value, ...updatedProduct }
  const idx = products.value.findIndex(p => p.id === updatedProduct.id)
  if (idx !== -1) {
    products.value[idx] = { ...products.value[idx], ...updatedProduct }
  }
  // Перезагружаем полные данные с сервера (витамины, is_own и т.д.)
  try {
    const { data } = await api.get(`/products/${updatedProduct.id}`)
    productDetails.value = data
    if (idx !== -1) {
      products.value[idx] = { ...products.value[idx], ...data }
    }
  } catch { /* оптимистичное обновление уже применено */ }
}

function onManualProductSubmitted(result) {
  showManualProduct.value = false
  const p = result.product
  if (p?.id) onProductSelect(p)
}

function onBarcodeSelect(product) {
  showBarcodeScanner.value = false
  if (product?.id) onProductSelect(product)
}

async function fetchProducts(reset = true) {
  if (!searchQuery.value) return
  if (reset) {
    loading.value = true
    products.value = []
    offset.value = 0
    hasMore.value = true
    fetchError.value = null
  } else {
    if (!hasMore.value || loadingMore.value) return
    loadingMore.value = true
  }
  try {
    const { data } = await api.get('/products/search', {
      params: { q: searchQuery.value, limit: LIMIT, offset: offset.value },
    })
    const newProducts = data.products || []
    if (reset) products.value = newProducts
    else products.value.push(...newProducts)
    offset.value += newProducts.length
    hasMore.value = newProducts.length === LIMIT
  } catch (err) {
    if (reset) fetchError.value = err
  } finally {
    loading.value = false
    loadingMore.value = false
  }
}

function onSearchInput() {
  clearTimeout(debounceTimer)
  if (!searchQuery.value) {
    products.value = []
    return
  }
  debounceTimer = setTimeout(() => fetchProducts(true), 300)
}

function clearSearch() {
  searchQuery.value = ''
  products.value = []
  inputRef.value?.focus()
}

// ── IntersectionObserver для infinite scroll ────────────────────
const productSentinelRef = ref(null)
const articleSentinelRef = ref(null)
let productObserver = null
let articleObserver = null

onMounted(async () => {
  productObserver = new IntersectionObserver(([entry]) => {
    if (entry.isIntersecting && searchQuery.value) fetchProducts(false)
  }, { rootMargin: '200px' })

  articleObserver = new IntersectionObserver(([entry]) => {
    if (entry.isIntersecting) fetchArticles(false)
  }, { rootMargin: '200px' })

  watch(productSentinelRef, el => {
    productObserver.disconnect()
    if (el) productObserver.observe(el)
  }, { immediate: true })

  watch(articleSentinelRef, el => {
    articleObserver.disconnect()
    if (el) articleObserver.observe(el)
  }, { immediate: true })

  // Restore articles tab + scroll position (e.g. returning from article page)
  if (activeTab.value === 'articles' && articles.value.length === 0) {
    await fetchArticles(true)
    const savedScroll = sessionStorage.getItem('kb_scrollTop')
    if (savedScroll && mainScrollRef.value) {
      await nextTick()
      mainScrollRef.value.scrollTop = parseInt(savedScroll, 10)
    }
    sessionStorage.removeItem('kb_scrollTop')
  }
})

onUnmounted(() => {
  productObserver?.disconnect()
  articleObserver?.disconnect()
})

// ── Статьи ────────────────────────────────────────────────
const articleQuery       = ref('')
const articles           = ref([])
const articlesLoading    = ref(false)
const articlesLoadingMore = ref(false)
const articlesHasMore    = ref(true)
const articlesOffset     = ref(0)
const articlesTotal      = ref(0)
const ARTICLES_LIMIT     = 20
const articleListRef     = ref(null)
const articleInputRef    = ref(null)
let articleDebounce      = null

async function fetchArticles(reset = true) {
  if (reset) {
    articlesLoading.value = true
    articles.value = []
    articlesOffset.value = 0
    articlesHasMore.value = true
    if (articleListRef.value) articleListRef.value.scrollTop = 0
  } else {
    if (!articlesHasMore.value || articlesLoadingMore.value) return
    articlesLoadingMore.value = true
  }
  try {
    const { data } = await api.get('/articles', {
      params: { q: articleQuery.value, limit: ARTICLES_LIMIT, offset: articlesOffset.value },
    })
    // excerpt уходит в v-html — относительные src из него абсолютизируются
    // здесь же, где и загружаются, как контент статьи в ArticleView
    const newArticles = (data.articles || []).map(a => ({ ...a, excerpt: absolutizeHtml(a.excerpt) }))
    if (reset) articles.value = newArticles
    else articles.value.push(...newArticles)
    articlesOffset.value += newArticles.length
    articlesTotal.value   = data.total || 0
    articlesHasMore.value = newArticles.length === ARTICLES_LIMIT
  } catch (err) {
    console.error('Articles fetch error:', err)
  } finally {
    articlesLoading.value     = false
    articlesLoadingMore.value = false
  }
}

function onArticleSearchInput() {
  clearTimeout(articleDebounce)
  articleDebounce = setTimeout(() => fetchArticles(true), 300)
}

function clearArticleSearch() {
  articleQuery.value = ''
  fetchArticles(true)
  articleInputRef.value?.focus()
}

// Загружаем статьи при первом переключении на вкладку
watch(activeTab, (tab) => {
  if (tab === 'articles' && articles.value.length === 0) {
    fetchArticles(true)
  }
})
</script>

<style scoped>
/* Перевёрнутые скругления у активного таба */
.tab-active::before,
.tab-active::after {
  content: '';
  position: absolute;
  bottom: 0;
  width: 14px;
  height: 14px;
  background-color: rgba(250, 243, 232, 0.75);
}
.tab-active::before {
  left: -14px;
  -webkit-mask: radial-gradient(circle at top left, transparent 14px, black 14.5px);
  mask: radial-gradient(circle at top left, transparent 14px, black 14.5px);
}
.tab-active::after {
  right: -14px;
  -webkit-mask: radial-gradient(circle at top right, transparent 14px, black 14.5px);
  mask: radial-gradient(circle at top right, transparent 14px, black 14.5px);
}
.tab-active.tab-first::before { display: none; }
.tab-active.tab-last::after { display: none; }

button, .tab-active {
  box-shadow: none;
}

/* Пилюли нутриентов: фон — цвет нутриента из дневника, текст — ink (контраст ≥ 4,4:1 на всех) */
.nutrient-pill {
  padding: 6px 14px;
  font-family: Inter, sans-serif;
  font-size: var(--fs-13);
  font-weight: 600;
  color: var(--ink);
}

</style>
